import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import { hideModal } from 'actions/common'
import { gridCreateTicket, gridEditTicket } from 'actions/grid'
import { GRID_TICKET_MODAL } from 'constants/modal-constants'
import { getCurrentModal } from 'selectors/common'
import { getCurrentEditSellableItemId } from 'selectors/grid'
import Modal from 'components/modal'

import GridTicketModal from './grid-ticket-modal'

class GridTicketModalContainer extends Component {

  constructor(props) {
    super(props)

    this.onCreateTicket = this.onCreateTicket.bind(this)
    this.onCancelTicket = this.onCancelTicket.bind(this)
    this.onEditTicket = this.onEditTicket.bind(this)
  }

  onCreateTicket(values) {
    this.props.gridCreateTicket(
      this.props.eventGroupId,
      {
        name: values.name,
        quantity: values.quantity,
        salePrice: values.salePrice,
        faceValue: values.faceValue,
        description: values.description,
        ticketIncrement: values.isGroupTicket ? values.ticketIncrement : '1',
      }
    )
    this.props.hideModal()
  }

  onEditTicket(values) {
    this.props.gridEditTicket(
      this.props.currentEditSellableItemId,
      {
        name: values.name,
        quantity: values.quantity,
        salePrice: values.salePrice,
        faceValue: values.faceValue,
        description: values.description,
        ticketIncrement: values.isGroupTicket ? values.ticketIncrement : '1',
      }
    )
    this.props.hideModal()
  }

  onCancelTicket() {
    this.props.hideModal()
  }

  render() {
    const isOpen = this.props.currentModal === GRID_TICKET_MODAL

    return (
      <Modal light wide closeModal={this.props.hideModal} isOpen={isOpen}>
        <GridTicketModal
          onCancelTicket={this.onCancelTicket}
          onCreateTicket={this.onCreateTicket}
          onEditTicket={this.onEditTicket}
          currentEditSellableItemId={this.props.currentEditSellableItemId}
        />
      </Modal>
    )
  }
}

GridTicketModalContainer.propTypes = {
  currentModal: PropTypes.string,
  hideModal: PropTypes.func,
  gridCreateTicket: PropTypes.func.isRequired,
  gridEditTicket: PropTypes.func.isRequired,
  eventGroupId: PropTypes.number.isRequired,
  currentEditSellableItemId: PropTypes.number,
}

const mapStateToProps = state => ({
  currentModal: getCurrentModal(state),
  currentEditSellableItemId: getCurrentEditSellableItemId(state),
})

const mapDispatchToProps = { hideModal, gridCreateTicket, gridEditTicket }

export default connect(mapStateToProps, mapDispatchToProps)(GridTicketModalContainer)



/** WEBPACK FOOTER **
 ** ./src/components/grid-ticket-modal/grid-ticket-modal-container.js
 **/